// Dashboard State

export default {
  sidebarLinks: [
    { id: 0, icon: 'home', title: 'Homepage', slug: '', to: '/', fa: false },
    { id: 0, icon: 'dashboard', title: 'Dashboard', slug: 'dashboard', to: '/dashboard', fa: false },
    { id: 1, icon: 'attach_money', title: 'Accounting', slug: 'accounting', to: '/accounting', fa: false },
    { id: 2, icon: 'fa-dolly', title: 'Inventory', slug: 'inventory', to: '/inventory', fa: true },
    { id: 3, icon: 'fa-chart-line', title: 'Reports', slug: 'reports', to: '/reports', fa: true },
    { id: 4, icon: 'fa-user-friends', title: 'Suppliers', slug: '', to: '/suppliers', fa: true },
    { id: 5, icon: 'fa-users', title: 'Customers', slug: 'customers', to: '/customers', fa: true },
    { id: 6, icon: 'fa-id-card-alt', title: 'Staff', slug: 'staff', to: '/staff', fa: true },
    { id: 7, icon: 'fa-cogs', title: 'Preferences', slug: 'settings', to: '/preferences', fa: true },
    { id: 0, icon: 'info', title: 'About', slug: 'about', to: '/about', fa: false }
  ],

  // sublinks 1st-level keys MUST match slugs spelling in the sidebarLinks above
  sidebarSubLinks: {
    accounting: [
      {
        id: 8,
        title: 'Payable & Receivable',
        active: true,
        isGroup: true,
        groupLinks: [
          { id: 31, title: 'Account Payable', to: '/accounting/account-payable' },
          { id: 32, title: 'Commission Payable', to: '/accounting/commission-payable' },
          { id: 33, title: 'Account Receivable', to: '/accounting/account-receivable' },
          { id: 34, title: 'Payrolls', to: '/accounting/payrolls' }
        ]
      },
      {
        id: 9,
        title: 'Expenses',
        isGroup: true,
        groupLinks: [
          { id: 35, title: 'Expenses', to: '/accounting/expenses' },
          { id: 36, title: 'Expense Types', to: '/accounting/expenses-types' },
          { id: 92, title: 'Taxes', to: '/accounting/taxes' }
        ]
      },
      {
        id: 10,
        title: 'Incomes',
        isGroup: true,
        groupLinks: [
          { id: 37, title: 'Incomes', to: '/accounting/incomes' },
          { id: 38, title: 'Income Types', to: '/accounting/incomes-types' }
        ]
      },
      {
        id: 11,
        title: 'Dollar Exchange',
        isGroup: true,
        groupLinks: [
          { id: 39, title: 'Sales', to: '/accounting/sales' },
          { id: 40, title: 'Sales Returns', to: '/accounting/sales-returns' },
          { id: 89, title: 'Quotations', to: '/accounting/quotations' },
          { id: 41, title: 'Dollar Rates', to: '/accounting/dollar-prices' },
          { id: 42, title: 'Currency Exchange', to: '/accounting/currency-exchanges' }
        ]
      },
      {
        id: 12,
        title: 'Purchase Products',
        isGroup: true,
        groupLinks: [
          { id: 43, title: 'Purchases', to: '/accounting/purchases' },
          { id: 44, title: 'Purchases Returns', to: '/accounting/purchases-returns' }
        ]
      },
      {
        id: 13,
        title: 'Cash & Cashiers',
        isGroup: true,
        groupLinks: [
          { id: 91, title: 'Cash Transactions', to: '/accounting/cash-transactions' },
          { id: 45, title: 'Cashiers', to: '/accounting/main-cashiers' },
          // { id: 46, title: 'Cash', to: '' },
          { id: 47, title: 'Banks', to: '/accounting/banks' },
          { id: 48, title: 'Remittances', to: '/accounting/remittance-office' }
        ]
      },
      {
        id: 14,
        title: 'Stockholders & Dividends',
        isGroup: true,
        groupLinks: [
          { id: 49, title: 'Stockholders', to: '/accounting/stockholders' },
          { id: 50, title: 'Dividends', to: '/accounting/dividends' }
        ]
      },
      {
        id: 15,
        title: 'Promotions',
        isGroup: true,
        groupLinks: [
          { id: 51, title: 'Promo Cards', to: '/accounting/promo-cards' },
          { id: 52, title: 'Promotions', to: '/accounting/promotions' }
        ]
      },
      {
        id: 16,
        title: 'Purchase Fixed Assets',
        isGroup: true,
        groupLinks: [
          { id: 53, title: 'Purchases', to: '/accounting/purchases-fixed-asset' },
          { id: 54, title: 'Purchases Returns', to: '/accounting/purchases-return-fixed-asset' }
        ]
      }

      // { title: 'Cashiers', to: '/accounting/cashiers' },
    ],
    inventory: [
      {
        id: 17,
        title: 'Inventory',
        active: true,
        isGroup: true,
        groupLinks: [
          { id: 55, title: 'Warehouse', to: '/inventory/inventory' },
          { id: 56, title: 'Transfers', to: '/inventory/transfers' },
          { id: 57, title: 'Orders & Receives', to: '/inventory/receives' },
          { id: 58, title: 'Product Shortages', to: '/inventory/product-shortages' },
          { id: 59, title: 'Destructed Assets', to: '/inventory/destructed-assets' }
        ]
      },
      {
        id: 18,
        title: 'Products',
        isGroup: true,
        groupLinks: [
          { id: 60, title: 'Products', to: '/inventory/products' },
          { id: 61, title: 'Product Types', to: '/inventory/product-types' }
        ]
      },
      {
        id: 19,
        title: 'Fixed Assets',
        isGroup: true,
        groupLinks: [
          { id: 62, title: 'Fixed Assets', to: '/inventory/fixed-assets' },
          { id: 63, title: 'Fixed Asset Types', to: '/inventory/fixed-asset-types' }
        ]
      },
      {
        id: 20,
        title: 'Productions',
        isGroup: true,
        groupLinks: [
          { id: 64, title: 'Weight Auditor', to: '/inventory/weight-auditor' },
          { id: 65, title: 'Productions', to: '/inventory/productions' },
          { id: 66, title: 'Mixtures', to: '/inventory/mixtures' },
          { id: 67, title: 'Raw Materials', to: '/inventory/raw-materials' },
          { id: 68, title: 'Factories', to: '/inventory/factories' }
        ]
      }
      // {
      //   title: 'Inventory Near Expiries',
      //   to: '/inventory/product-near-expiries'
      // },
      // {
      //   title: 'Inventory Expired',
      //   to: '/inventory/product-expired'
      // }
    ],
    reports: [
      {
        id: 21,
        title: 'Inventory Reports',
        active: true,
        isGroup: true,
        groupLinks: [
          { id: 69, title: 'Inventories', to: '/reports/total-inventories-report' },
          { id: 70, title: 'Product Shortages', to: '/reports/total-product-shortages-report' },
          { id: 71, title: 'Destructed Assets', to: '/reports/destructed-assets-report' },
          { id: 73, title: 'Productions', to: '/reports/productions-report' }
        ]
      },
      {
        id: 22,
        title: 'Accounting Reports',
        isGroup: true,
        groupLinks: [
          { id: 74, title: 'Expenses', to: '/reports/expenses-report' },
          { id: 74, title: 'Expenses Type', to: '/reports/expenses-type-report' },
          { id: 75, title: 'Incomes', to: '/reports/incomes-report' },
          { id: 76, title: 'Purchases', to: '/reports/purchases-report' },
          { id: 77, title: 'Purchases Returns', to: '/reports/purchases-returns-report' },
          { id: 78, title: 'Sales', to: '/reports/sales-report' },
          { id: 79, title: 'Sales Returns', to: '/reports/sales-returns-report' }
        ]
      },
      {
        id: 23,
        title: 'Financial Statements Reports',
        isGroup: true,
        groupLinks: [
          // { id: 80, title: 'Chart of Accounts', to: '/reports/chart-of-accounts' },
          { id: 82, title: 'General Journal', to: '/reports/general-journal-report' },
          { id: 83, title: 'General Ledger', to: '/reports/general-ledger-report' },
          { id: 84, title: 'Trial Balance', to: '/reports/trial-balance' },
          { id: 85, title: 'Income Statement', to: '/reports/incomes-statement' },
          // { id: 86, title: 'Retained Earnings', to: '' },
          { id: 87, title: 'Balance Sheet', to: '/reports/balance-sheet' },
          { id: 81, title: 'Closing Entries', to: '/reports/closing-entries' }
        ]
      }

      // {
      //   title: 'Total Inventories Near Expiries',
      //   to: '/reports/total-product-near-expiries-report'
      // },
      // {
      //   title: 'Total Inventories Expired',
      //   to: '/reports/total-product-expired-report'
      // },
    ],
    customers: [
      { id: 24, title: 'Customers', to: '/customers/customers' },
      { id: 25, title: 'Groups', to: '/customers/customers-groups' }
    ],
    staff: [
      { id: 26, title: 'Staff', to: '/staff/staff' },
      { id: 27, title: 'Salesmen', to: '/staff/salesmen', dividerAfter: true },
      { id: 28, title: 'System Logs', to: '/staff/system-logs' }
    ],
    settings: [
      { id: 150, title: 'System Features', to: '/preferences/system-features' },
      { id: 29, title: 'System Configurations', to: '/preferences/system-configurations' },
      { id: 30, title: 'Outlets', to: '/preferences/outlets' },
      { id: 88, title: 'Opening Balance', to: '/preferences/opening-balance' }
    ]
  },
  toggleSidebarSubMenu: false,
  currentSubLinks: {},
  sidebarWidth: 120,
  appBarTitle: {},
  cashBalance: {},
  allBalance: {}
}
